import { render, staticRenderFns } from "./_basicProductId.vue?vue&type=template&id=0e846dc8"
import script from "./_basicProductId.vue?vue&type=script&lang=js"
export * from "./_basicProductId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports